export enum ItemStatus {
  CREATE = 'create',
  MODIFIED = 'modified',
  REMOVED = 'removed',
}
